import { useEffect, useRef } from 'react';

import Slider from './Components/Slider.js';
import Calendar from './Components/Kalender.js';
import Member from './Components/member.js';
import PreviewPraedikner from './Components/PreviewPraedikner.js';
import BlogPreview from './Components/BlogPreview.js';
import Signup from '../components/Signup.js';
import PageState from '../components/PageState.js';
import FadeInSection from '../components/FadeInSection.js';


function Forside({ onStateChange }) {
  const observer = useRef(null);

  useEffect(() => {
    observer.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('show');
          } else {
            const elementRect = entry.target.getBoundingClientRect();
            const isAboveViewport = elementRect.bottom < 0;
            if (!isAboveViewport) {
              // Optional: entry.target.classList.remove('show');
            }
          }
        });
      },
      { threshold: 0.5 }
    );

    const hiddenElements = document.querySelectorAll('.hidden');
    hiddenElements.forEach((el) => observer.current.observe(el));

    return () => {
      hiddenElements.forEach((el) => observer.current.unobserve(el));
    };
  }, []);
  return(
    <PageState
      pageName="Forside"
      render={({ data}) => {

        const { slider, calendar, pradiken, member,blogPreview, nyhed } = data;

        return (
          <>
            <Slider data={slider}/>
            <Calendar content={calendar} />
            <PreviewPraedikner onStateChange={onStateChange} content={pradiken} />
            
            <Member member={member}/>
            <BlogPreview content={blogPreview}/>
            <section id={nyhed.id}>
              <FadeInSection>
                <Signup input={false} title={nyhed.header} text={nyhed.text} endpoint="/mail" />
              </FadeInSection>
            </section>
          </>
        );
      }
    }/>
  );
}

export default Forside;
